import { render, staticRenderFns } from "./Form418_v2_tab1.vue?vue&type=template&id=6ea72516&scoped=true&"
import script from "./Form418_v2_tab1.vue?vue&type=script&lang=js&"
export * from "./Form418_v2_tab1.vue?vue&type=script&lang=js&"
import style0 from "./Form418_v2_tab1.vue?vue&type=style&index=0&id=6ea72516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea72516",
  null
  
)

export default component.exports